import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "../../../axios";
import { Loading } from "../../Other/Loading";
import moment from "moment/moment";
import "./page.scss";
import ".";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import Forms from "./Forms";
import Pagination from "../Teachers/MemberList/Pagination";
import editIcon from "../../../assets/icons/icon-edit.png";
import deleteIcon from "../assets/icons/promotion.png";
import { CourseBuilderStaticData } from "../../../_constants/staticData";
import { downloadCSV } from "../../../_helpers";
import AddMenu from "./AddMenu/AddMenu";
import BulkUploadOverlay from "../Shared/BulkUpload/BulkUploadOverlay";
import AddPageMeta from "./AddPageMeta";

function index() {
  const [instructorData, setInstructorData] = useState([]);
  const [instructorStats, setInstructorStats] = useState();
  const [singlePage, setSinglePage] = useState();
  const [pageMetaShow, setPageMetaShow] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [instructorId, setInstructorId] = useState(0);
  const [dateRangePicker, setDateRangePicker] = useState(false);
  const [dateToggle, setDateToggle] = useState(false);
  const [editInstructorData, setEditInstructorData] = useState([]);
  const [filter, setFilter] = useState({
    status: "",
    startDate: "",
    endDate: "",
    page: 1,
    itemsPerPage: 10,
  });
  const [page, setPage] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [pageMetaModal, setPageMetaModal] = useState(false);
  const [addMenu, setAddMenu] = useState(false);
  const [pageMetaAddMenu, setPageMetaAddMenu] = useState(false);
  const [addBulkUsers, setAddBulkUsers] = useState(false);
  const [isUploded, setIsUploaded] = useState(true);

  
  //  to handle date picker
  const refOne = useRef(null);
  // useEffect(()=>{
  //     fetch()
  // },[])
  const fetch = async () => {
    try {
      const res = await axiosInstance.get(
        `pages?status=${filter.status}&page=${filter.page}&perPage=${filter.itemsPerPage}`
      );

      //console.log("data", res.data?.pagination);
      setInstructorData(res.data?.data);
      setPage(res.data?.pagination?.totalPages);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchInstructorStats = async () => {
      try {
        const res = await axiosInstance.get("admin/instructor-statistics");
        setInstructorStats(res.data.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchInstructorStats();
  }, [isUploded]);


  useEffect(() => {
    fetch();
    document.addEventListener("keydown", hideOnEscape, true);
    document.addEventListener("click", hideOnClickOutside, true);
  }, [filter, modal, confirmDelete, isUploded]);

  const handleSelectChange = (e) => {
    setFilter({ ...filter, itemsPerPage: e.target.value });
  };

  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const hideOnEscape = (e) => {
    if (e.key === "Escape") {
      setDateToggle(false);
    }
  };

  const hideOnClickOutside = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      setDateToggle(false);
    }
  };

  const handleStatusFilter = (e) => {
    setFilter({ ...filter, status: e.target.value });
  };
  const handleDateRangeFilter = (item) => {
    setFilter({
      ...filter,
      startDate: moment(item.selection.startDate).format("YYYY-MM-D"),
      endDate: moment(item.selection.endDate).format("YYYY-MM-D"),
    });
    setRange([item.selection]);
  };

  const deleteInstructor = async (pageId) => {
    try {
      setInstructorId(pageId);
      const res = await axiosInstance.get(`pageById?pageId=${pageId}`);
      //console.log("pageid", res);
      setLoading(false);
      setPageMetaShow(true);
      setSinglePage(res.data?.data);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const handleDeleteInstructor = async () => {
    try {
      const res = await axiosInstance.post("admin/user/delete/", {
        userId: instructorId,
      });
      if (res) {
        setConfirmDelete(false);
      }
    } catch (error) {
      console.log(error);
      setConfirmDelete(false);
    }
  };


  const handleEditInstructor = (data) => {
    setModal(true);
    setEditInstructorData(data);
  };

  const handleAddInstructor = () => {
    setModal(true);
    setEditInstructorData([]);
    setAddMenu(false);
  };
  const handleAddPageMeta = () => {
    setPageMetaModal(true);
    setEditInstructorData([]);
    setAddMenu(false);
  };
  const handleInstructorList = async () => {
    try {
      const res = await axiosInstance.get("/admin/export/instructors");
      downloadCSV(res?.data, "Instructor-list");
    } catch (error) {
      console.error("Error exporting instructor list:", error);
    }
  };


  const handleAddBulkUsers = (type) => {
    setAddBulkUsers(true);
    setAddMenu(false);
  };

  return (
    <div className="width-0">
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="dashboard-container-new">
            <p>Pages</p>
            <div>
              {/* <button className="lastmonth-btn">Last Month</button> */}
              <button className="export-btn" onClick={handleInstructorList}>
                Export
              </button>
            </div>
          </div>
          {/* <div className="flex-dashboard-new-1">
            {staticData.map((item, index) => (
              <div className={`box-shadow-06 ${item.boxShadow}`} key={index}>
                <p className="font-custom-p">{item.name}</p>
                <p className={`font-increase ${item.color}`}>{item.total}</p>
              </div>
            ))}
          </div> */}
          <div className="page-data-new">
            <div>
              {instructorData?.length > 0 ? (
                <p className="showing-result">
                  Showing {filter.page} page of {filter.itemsPerPage} results
                </p>
              ) : (
                <p className="showing-result">Showing 0 result</p>
              )}
            </div>

            <div className="pagination-flex">
              <div className=" margin-r-n-15">
                <button
                  onClick={() =>
                    pageMetaShow
                      ? handleAddPageMeta()
                      : setAddMenu((state) => !state)
                  }
                  className="export-btn"
                >
                  Add <span>&#10009;</span>
                </button>
                {addMenu && (
                  <AddMenu
                    setAddMenu={setAddMenu}
                    handleAddBulkUsers={handleAddBulkUsers}
                    handleAddUser={handleAddInstructor}
                    role="Admin"
                  />
                )}
              </div>
              <div className="pagination-date">
                {dateRangePicker === false ? (
                  <>
                    <input
                      type="text"
                      placeholder="Date Range"
                      className="date-ranger-instructor"
                      onClick={() => {
                        setDateRangePicker(true);
                        setDateToggle(true);
                      }}
                    />
                  </>
                ) : (
                  <input
                    type="text"
                    value={`${moment(range[0].startDate).format(
                      "MM/DD/YYYY"
                    )} to ${moment(range[0].endDate).format("MM/DD/YYYY")}`}
                    placeholder="Date Range"
                    className="date-ranger-instructor-updated"
                    onClick={() => setDateToggle(true)}
                  />
                )}

                <div className="dateWrap" ref={refOne}>
                  {dateToggle && (
                    <DateRange
                      onChange={(item) => handleDateRangeFilter(item)}
                      editableDateInputs={true}
                      moveRangeOnFirstSelection={false}
                      ranges={range}
                      months={1}
                      direction="horizontal"
                      className="dateElement"
                    />
                  )}
                </div>
              </div>
              <div>
                <div className="pagination-select">
                  <select
                    className="select-dropdown-instructor-2"
                    onChange={handleStatusFilter}
                  >
                    <option value="">Select Status</option>
                    <option value="0">Pending</option>
                    <option value="1">Completed</option>
                  </select>
                </div>
              </div>
              <div>
                <p className="item-page-result">Item per page</p>
              </div>
              <div className="pagination-select">
                <select
                  className="select-dropdown-instructor-1"
                  onChange={(e) => handleSelectChange(e)}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={40}>40</option>
                  <option value={50}>50</option>
                </select>
              </div>
            </div>
          </div>
          {pageMetaShow ? (
            <div className="instructor-table">
              {singlePage?.length === 0 ? (
                <h2 className="no-data-found">No data found</h2>
              ) : (
                <table className="table-width-100">
                  <thead>
                    <th>Sr.no</th>
                    <th>Field Name</th>
                    <th>Field Value</th>
                    <th></th>
                  </thead>

                  <tbody>
                    {singlePage?.length > 0 ? (
                      singlePage?.map((ele, index) => {
                        return (
                          <tr key={index}>
                            <td className="cell">
                              {filter?.itemsPerPage * filter?.page -
                                filter?.itemsPerPage +
                                index +
                                1}
                            </td>

                            <td className="cell">{ele.field_name}</td>
                            <td className="cell">
                              {ele.field_type == "file" ? (
                                <img
                                  src={ele.field_value}
                                  alt={ele.field_value}
                                   loading="lazy"
                                />
                              ) : (
                                ele.field_value
                              )}
                            </td>

                            {/* <td className="cell">
                                                <img
                                                    onClick={() => handleEditInstructor(ele)}
                                                    src={editIcon}
                                                    alt="edit"
                                                />
                                            </td> */}
                            <td
                              className="cell"
                              onClick={() => handleAddPageMeta(ele.page_id)}
                            >
                              <img src={deleteIcon} alt="delete"  loading="lazy" />
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <h2 className="no-data-found">No data found</h2>
                    )}
                  </tbody>
                </table>
              )}
              {confirmDelete === true && (
                <OverlayContainer>
                  <div className="alert-dialog-inner">
                    <div
                      className="alert-dialog-close"
                      onClick={() => setConfirmDelete(!confirmDelete)}
                    >
                      <div>
                        <i className="icon check"></i>
                      </div>
                    </div>
                    <div className="alert-title">Warning!</div>
                    <div className="alert-message">
                      {CourseBuilderStaticData.deleteInstructorOverlay.header}
                    </div>

                    <div className="alert-close-btn">
                      <a className="btn-save" onClick={handleDeleteInstructor}>
                        OK
                      </a>

                      <a
                        className="btn-cancel"
                        onClick={() => setConfirmDelete(false)}
                      >
                        CANCEL
                      </a>
                    </div>
                  </div>
                </OverlayContainer>
              )}
            </div>
          ) : (
            <div className="instructor-table">
              {instructorData?.length === 0 ? (
                <h2 className="no-data-found">No data found</h2>
              ) : (
                <table className="table-width-100">
                  <thead>
                    <th>Sr.no</th>
                    <th>Page Name</th>
                    <th>Page Slug</th>
                    <th>Active</th>
                    <th></th>
                  </thead>

                  <tbody>
                    {instructorData?.length > 0 ? (
                      instructorData?.map((ele, index) => {
                        return (
                          <tr key={index}>
                            <td className="cell">
                              {filter?.itemsPerPage * filter?.page -
                                filter?.itemsPerPage +
                                index +
                                1}
                            </td>

                            <td className="cell">{ele.page_name}</td>
                            <td className="cell">{ele.page_slug}</td>
                            <td className="cell">
                              <span
                                style={{
                                  backgroundColor: ele.is_active
                                    ? "#264b82"
                                    : "#36b9df",
                                  color: "white",
                                }}
                              >
                                {ele?.status ? "Completed" : "Pending"}
                              </span>
                            </td>
                            {/* <td className="cell">
                                                        <img
                                                            onClick={() => handleEditInstructor(ele)}
                                                            src={editIcon}
                                                            alt="edit"
                                                        />
                                                    </td> */}
                            <td
                              className="cell"
                              onClick={() => deleteInstructor(ele.page_id)}
                            >
                              <img src={deleteIcon} alt="delete"  loading="lazy"/>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <h2 className="no-data-found">No data found</h2>
                    )}
                  </tbody>
                </table>
              )}
              {confirmDelete === true && (
                <OverlayContainer>
                  <div className="alert-dialog-inner">
                    <div
                      className="alert-dialog-close"
                      onClick={() => setConfirmDelete(!confirmDelete)}
                    >
                      <div>
                        <i className="icon check"></i>
                      </div>
                    </div>
                    <div className="alert-title">Warning!</div>
                    <div className="alert-message">
                      {CourseBuilderStaticData.deleteInstructorOverlay.header}
                    </div>

                    <div className="alert-close-btn">
                      <a className="btn-save" onClick={handleDeleteInstructor}>
                        OK
                      </a>

                      <a
                        className="btn-cancel"
                        onClick={() => setConfirmDelete(false)}
                      >
                        CANCEL
                      </a>
                    </div>
                  </div>
                </OverlayContainer>
              )}
            </div>
          )}
          {/* Pagination */}
          <div className="pageNumbers-sudents">
            {instructorData?.length >= 0 ? (
              <Pagination
                className="pageNumbers-sudents"
                currentPage={filter.page}
                totalCount={filter.itemsPerPage}
                pageSize={page}
                onPageChange={(page) => setFilter({ ...filter, page: page })}
              />
            ) : (
              ""
            )}{" "}
          </div>
          {pageMetaModal && (
            <OverlayContainer>
              <AddPageMeta
                setModal={setPageMetaModal}
                title="Page Meta"
                instructorId={instructorId}
                editData={editInstructorData} // Pass the existing data to edit
              />
            </OverlayContainer>
          )}
          {modal && (
            <OverlayContainer>
              <Forms
                setModal={setModal}
                title="Page"
                role={4}
                editData={editInstructorData}
              />
            </OverlayContainer>
          )}
          {addBulkUsers && (
            <OverlayContainer>
              <BulkUploadOverlay
                onCancel={setAddBulkUsers}
                role={4}
                setIsUploaded={setIsUploaded}
              />
            </OverlayContainer>
          )}
        </>
      )}
    </div>
  );
}

export default index;
